<h3 mat-dialog-title>Välj ansvarig</h3>
<mat-dialog-content [style.padding-top.px]="2">
  <mat-form-field>
    <mat-label>Ansvarig</mat-label>
    <mat-select [formControl]="selectDelegate">
      <mat-option [value]=""/>
      @for (user of adminService.users$ | async; track user) {
        <mat-option
          [value]="user.name">
          {{ user.name }}
        </mat-option>
      }
    </mat-select>
  </mat-form-field>
</mat-dialog-content>
<mat-dialog-actions>
  <button mat-dialog-close="cancel" matButton="outlined">Avbryt
  </button>
  <button (click)="save()"
          matDialogClose
          [disabled]="selectedValue === selectDelegate.value"
          matButton="filled">Spara
  </button>
</mat-dialog-actions>

